"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepWellHeating = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var DeepWellHeating = (function (_super) {
    __extends(DeepWellHeating, _super);
    function DeepWellHeating() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.DEEP_WELL_HEATING,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            cost: 13,
            productionBox: Units_1.Units.of({ energy: 1 }),
            tr: { temperature: 1 },
            metadata: {
                cardNumber: '003',
                description: 'Increase your Energy production 1 step. Increase temperature 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1); }).temperature(1);
                }),
            },
        }) || this;
    }
    DeepWellHeating.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return player.game.increaseTemperature(player, 1);
    };
    return DeepWellHeating;
}(Card_1.Card));
exports.DeepWellHeating = DeepWellHeating;
